var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "grid is-col-min-15" }, [
        _c("div", { staticClass: "cell" }, [
          _c("article", { staticClass: "box" }, [
            _c("div", { staticClass: "columns is-gapless" }, [
              _c("div", { staticClass: "column" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v("Detail Info "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.innerValue.isNew,
                          expression: "!innerValue.isNew",
                        },
                      ],
                      staticClass: "icon has-text-info tooltip is-tooltip-info",
                      class: [_vm.canChangeReadOnly ? "readonly-pointer" : ""],
                      attrs: {
                        "data-tooltip": _vm.readOnlyView
                          ? "Invoice is locked"
                          : "Invoice is unlocked",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toogleReadOnly()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon mdi",
                        class: [
                          _vm.readOnlyView
                            ? "mdi-lock-outline"
                            : "mdi-lock-open-outline",
                        ],
                      }),
                    ]
                  ),
                ]),
                _vm.innerValue.gstPaidDate
                  ? _c("p", { staticClass: "subtitle has-text-warning" }, [
                      _vm._v("Only Reason & Remarks can be updated"),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "column is-narrow" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.innerValue.isNew,
                        expression: "innerValue.isNew",
                      },
                    ],
                    staticClass:
                      "tag is-success is-pulled-right tooltip is-tooltip-success",
                    attrs: {
                      "data-tooltip": "Previous Total Adjustments Amount",
                    },
                  },
                  [
                    _vm._v(
                      "Previous Adjustments " +
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.innerValue.prevAdjustmentAmount,
                            _vm.$userInfo.locale
                          )
                        )
                    ),
                  ]
                ),
                _vm.innerValue.gstPaidDate
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "tag is-warning is-pulled-right tooltip is-tooltip-warning",
                        attrs: {
                          "data-tooltip":
                            "GST has been paid. Only Reason & Remarks can be updated",
                        },
                      },
                      [
                        _vm._v(
                          "GST paid on " +
                            _vm._s(
                              _vm.$filters.formatDateLocale(
                                _vm.innerValue.gstPaidDate,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Adjustment Note No."),
                ]),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    staticClass: "input is-static",
                    attrs: {
                      type: "text",
                      placeholder: "Adjustment Note No.",
                      readonly: "",
                    },
                    domProps: {
                      value: `${_vm.innerValue.prefix}${_vm.innerValue.invoiceNo}${_vm.innerValue.suffix}`,
                    },
                  }),
                ]),
              ]),
              _vm.gstPaid || _vm.readOnlyView
                ? _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Invoice Date"),
                    ]),
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatDateLocale(
                          _vm.invoiceDate,
                          _vm.$userInfo.locale
                        ),
                      },
                    }),
                  ])
                : _vm.$userInfo && !_vm.gstPaid && _vm.invoiceDate
                ? _c(
                    "div",
                    { staticClass: "field is-narrow" },
                    [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Issue Date"),
                      ]),
                      _c("v-date-picker", {
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "min-date": _vm.firstDayOfMonth,
                          timezone: _vm.$filters.getIanaTimezone(),
                        },
                        on: { input: _vm.issueDateInputEvent },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    { staticClass: "control has-icons-left" },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            staticClass: "input",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Date To...",
                                              readonly: "",
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.selectedIssueDate,
                          callback: function ($$v) {
                            _vm.selectedIssueDate = $$v
                          },
                          expression: "selectedIssueDate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Applies to Invoice No."),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  staticClass: "input is-static",
                  attrs: {
                    type: "text",
                    placeholder: "Applies to Invoice No.",
                    readonly: "",
                  },
                  domProps: { value: _vm.innerValue.applyToInvoiceNo },
                }),
              ]),
              _c("label", { staticClass: "label" }, [
                _vm._v("Applies to Quote No."),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  staticClass: "input is-static",
                  attrs: {
                    type: "text",
                    placeholder: "Applies to Quote No.",
                    readonly: "",
                  },
                  domProps: { value: _vm.innerValue.quoteNo },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("G/L Account")]),
              _vm.gstPaid || _vm.readOnlyView
                ? _c("div", { staticClass: "field" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.selectedGlAccountObject.displayName,
                      },
                    }),
                  ])
                : _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _vm.glAccountListCombo
                        ? _c(
                            "multiselect",
                            {
                              attrs: {
                                options: _vm.glAccountListCombo,
                                placeholder: "Select account",
                                label: "displayName",
                                "track-by": "accountNo",
                                "deselect-label": "Can't remove this value",
                                "allow-empty": false,
                              },
                              model: {
                                value: _vm.selectedGlAccountObject,
                                callback: function ($$v) {
                                  _vm.selectedGlAccountObject = $$v
                                },
                                expression: "selectedGlAccountObject",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "has-text-danger",
                                  attrs: { slot: "noResult" },
                                  slot: "noResult",
                                },
                                [_vm._v("G/L account not found.")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ]),
            !_vm.innerValue.isNew
              ? _c("div", { staticClass: "field is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Exported")]),
                  _c(
                    "div",
                    { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.innerValue.exported,
                            expression: "innerValue.exported",
                          },
                        ],
                        attrs: {
                          id: "chk-invoice-exported",
                          name: "chk-invoice-exported",
                          type: "checkbox",
                          disabled:
                            _vm.readOnlyView || !_vm.$userInfo.isSupportUser,
                        },
                        domProps: {
                          checked: Array.isArray(_vm.innerValue.exported)
                            ? _vm._i(_vm.innerValue.exported, null) > -1
                            : _vm.innerValue.exported,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.innerValue.exported,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.innerValue,
                                    "exported",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.innerValue,
                                    "exported",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.innerValue, "exported", $$c)
                            }
                          },
                        },
                      }),
                      _vm._m(0),
                    ]
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "is-divider" }),
            _vm.showInvoiceItems
              ? _c("div", [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Selected Misc. Items"),
                  ]),
                  _c(
                    "table",
                    {
                      staticClass:
                        "table is-bordered is-striped is-narrow is-fullwidth",
                    },
                    [
                      _vm._m(1),
                      _c(
                        "tfoot",
                        { staticClass: "has-multiple-totals no-border" },
                        [
                          _c(
                            "tr",
                            {
                              staticClass: "has-border-bottom-4",
                              class: `debtor-adjustment-background-text-${_vm.$theme.name}`,
                            },
                            [
                              _vm._m(2),
                              _c("th", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.innerValue.totalExGst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "tr",
                            {
                              staticClass: "has-border-bottom-4",
                              class: `debtor-adjustment-background-primary-${_vm.$theme.name}`,
                            },
                            [
                              _c("th", { staticClass: "has-text-left" }, [
                                _vm._v("GST"),
                              ]),
                              _c("th", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.innerValue.gst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "tr",
                            {
                              class: `debtor-adjustment-background-success-${_vm.$theme.name}`,
                            },
                            [
                              _vm._m(3),
                              _c("th", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.innerValue.totalIncGst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm.activeItems.length > 0
                        ? _c(
                            "tbody",
                            _vm._l(_vm.activeItems, function (item) {
                              return _c("tr", { key: item.invoiceItemId }, [
                                _c("td", [
                                  _vm._v(_vm._s(item.invoiceItemDesc)),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        item.totalIncGst,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            }),
                            0
                          )
                        : _c("tbody", [_vm._m(4)]),
                    ]
                  ),
                ])
              : _c("div", [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Adjust Revenue Totals"),
                  ]),
                  _c(
                    "table",
                    {
                      staticClass:
                        "table is-bordered is-striped is-narrow is-fullwidth",
                    },
                    [
                      _vm._m(5),
                      _c(
                        "tfoot",
                        { staticClass: "has-multiple-totals no-border" },
                        [
                          _c(
                            "tr",
                            {
                              staticClass: "has-border-bottom-4",
                              class: `debtor-adjustment-background-text-${_vm.$theme.name}`,
                            },
                            [
                              _vm._m(6),
                              _c("th", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.innerValue.totalExGst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "tr",
                            {
                              staticClass: "has-border-bottom-4",
                              class: `debtor-adjustment-background-primary-${_vm.$theme.name}`,
                            },
                            [
                              _c("th", { staticClass: "has-text-left" }, [
                                _vm._v("GST "),
                                _c("span", { staticClass: "subtext" }, [
                                  _vm._v(
                                    "(" + _vm._s(_vm.innerValue.gstRate) + "%)"
                                  ),
                                ]),
                              ]),
                              _c("th", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.innerValue.gst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "tr",
                            {
                              class: `debtor-adjustment-background-success-${_vm.$theme.name}`,
                            },
                            [
                              _vm._m(7),
                              _c("th", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.innerValue.totalExGst +
                                        _vm.innerValue.gst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.activeItems, function (item) {
                            return _c("tr", { key: item.invoiceItemId }, [
                              _c("td", [_vm._v(_vm._s(item.glAccountName))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      item.totalExGst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ])
                          }),
                          !_vm.innerValue.gstItem.isDeleted
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.innerValue.gstItem.glAccountName)
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        _vm.innerValue.gstItem.totalExGst,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
          ]),
        ]),
        _c("div", { staticClass: "cell is-flex" }, [
          _c("article", { staticClass: "box is-flex-grow-1" }, [
            _c("p", { staticClass: "title" }, [_vm._v("Adjustment Reason")]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Reason")]),
              _c("div", { staticClass: "control" }, [
                !_vm.readOnlyView
                  ? _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerValue.quickInvoiceDesc,
                          expression: "innerValue.quickInvoiceDesc",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: { placeholder: "", disabled: _vm.readOnlyView },
                      domProps: { value: _vm.innerValue.quickInvoiceDesc },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.innerValue,
                            "quickInvoiceDesc",
                            $event.target.value
                          )
                        },
                      },
                    })
                  : _c("span", [
                      _vm._v(_vm._s(_vm.innerValue.quickInvoiceDesc)),
                    ]),
              ]),
            ]),
            _c("p", { staticClass: "title" }, [_vm._v("Remarks")]),
            !_vm.readOnlyView
              ? _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control is-pulled-right" }, [
                    _c("div", { staticClass: "is-pulled-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-small is-success tooltip",
                          attrs: { "data-tooltip": "Add Remarks" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleRemarkModal()
                            },
                          },
                        },
                        [_vm._m(8), _c("span", [_vm._v("Remarks")])]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Remarks")]),
              _c(
                "table",
                {
                  staticClass:
                    "table is-bordered is-striped is-narrow is-fullwidth",
                },
                [
                  _c("thead"),
                  _vm.activeRemarks.length > 0
                    ? _c(
                        "tbody",
                        _vm._l(_vm.activeRemarks, function (remark, index) {
                          return _c("tr", { key: remark.remarkId }, [
                            _c("td", { staticClass: "is-content-width" }, [
                              _c("span", { staticClass: "tag is-info" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimeLocale(
                                      remark.remarkDateTime,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm.readOnlyView
                              ? _c("td", [
                                  _c("div", { staticClass: "control" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(remark.remarks)),
                                    ]),
                                  ]),
                                ])
                              : _c("td", [
                                  _c("div", { staticClass: "control" }, [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: remark.remarks,
                                          expression: "remark.remarks",
                                        },
                                      ],
                                      staticClass: "textarea",
                                      attrs: { placeholder: "" },
                                      domProps: { value: remark.remarks },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            remark,
                                            "remarks",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                            !_vm.readOnlyView
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-centered is-content-width has-vertical-middle",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "button is-danger is-small is-inverted",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteRemark(
                                              remark,
                                              index,
                                              _vm.remarkTypes.Remark
                                            )
                                          },
                                        },
                                      },
                                      [_vm._m(9, true)]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        }),
                        0
                      )
                    : _c("tbody", [_vm._m(10)]),
                ]
              ),
            ]),
            !_vm.readOnlyView
              ? _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control is-pulled-right" }, [
                    _c("div", { staticClass: "is-pulled-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-small is-success tooltip",
                          attrs: { "data-tooltip": "Add Remarks" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleRemarkModal()
                            },
                          },
                        },
                        [_vm._m(11), _c("span", [_vm._v("Remarks")])]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Printed Remarks"),
              ]),
              _c(
                "table",
                {
                  staticClass:
                    "table is-bordered is-striped is-narrow is-fullwidth",
                },
                [
                  _c("thead"),
                  _vm.activePrintedRemarks.length > 0
                    ? _c(
                        "tbody",
                        _vm._l(
                          _vm.activePrintedRemarks,
                          function (remark, index) {
                            return _c("tr", { key: remark.remarkId }, [
                              _c("td", { staticClass: "is-content-width" }, [
                                _c("span", { staticClass: "tag is-info" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatDateTimeLocale(
                                        remark.remarkDateTime,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm.readOnlyView
                                ? _c("td", [
                                    _c("div", { staticClass: "control" }, [
                                      _c("span", [
                                        _vm._v(_vm._s(remark.remarks)),
                                      ]),
                                    ]),
                                  ])
                                : _c("td", [
                                    _c("div", { staticClass: "control" }, [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: remark.remarks,
                                            expression: "remark.remarks",
                                          },
                                        ],
                                        staticClass: "textarea",
                                        attrs: { placeholder: "" },
                                        domProps: { value: remark.remarks },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              remark,
                                              "remarks",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]),
                              !_vm.readOnlyView
                                ? _c(
                                    "td",
                                    {
                                      staticClass:
                                        "has-text-centered is-content-width has-vertical-middle",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-danger is-small is-inverted",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteRemark(
                                                remark,
                                                index,
                                                _vm.remarkTypes.PrintedRemark
                                              )
                                            },
                                          },
                                        },
                                        [_vm._m(12, true)]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          }
                        ),
                        0
                      )
                    : _c("tbody", [_vm._m(13)]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.value && _vm.isRemarkModalActive
        ? _c(
            "remark-modal",
            {
              attrs: {
                "show-remark": true,
                "show-printed-remark": true,
                "show-recurring-remark": true,
                active: _vm.isRemarkModalActive,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRemarkModalActive = $event
                },
                add: _vm.addRemarks,
                cancel: function ($event) {
                  return _vm.toggleRemarkModal()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Add Debtor Adjustment Remarks"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Exported")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Description")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v(" Total ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "3" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-dots-horizontal mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Account")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v(" Total ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "2" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-comment-text-outline mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "2" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-comment-text-outline mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }